// extracted by mini-css-extract-plugin
module.exports = {"p5Canvas":"Map_p5Canvas__6-n-l","map":"Map_map__2S7Si"};